export default "__VITE_ASSET__D_wm$jDG__"